'use strict';

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var React = require('react');

var React__default = _interopDefault(React);

var classNames = _interopDefault(require('classnames'));

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var LayoutTextBoxInput =
/*#__PURE__*/
function (_Component) {
  _inherits(LayoutTextBoxInput, _Component);

  function LayoutTextBoxInput(props) {
    var _this;

    _classCallCheck(this, LayoutTextBoxInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LayoutTextBoxInput).call(this, props));
    _this.handleInputChange = _this.handleInputChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onInputChangeFinish = _this.onInputChangeFinish.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleKeyPress = _this.handleKeyPress.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleKeyUp = _this.handleKeyUp.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.state = {
      value: props.value || '',
      focused: false
    };
    return _this;
  }

  _createClass(LayoutTextBoxInput, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value) {
        this.setState({
          value: nextProps.value
        });
      }
    }
  }, {
    key: "onInputChangeFinish",
    value: function onInputChangeFinish(lastKey) {
      var value;

      if (this.input.value !== this.props.value) {
        value = this.input.value || '';
        this.setState({
          value: value,
          focused: false
        });
      } else {
        value = this.props.value || '';
        this.setState({
          value: value,
          focused: false
        });
      }

      this.props.onChange && this.props.onChange(value, lastKey);
      this.input.blur();
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp(e) {
      if (this.props.handleKeyUp) {
        this.props.handleKeyUp(e.target.value, e.key);
      }
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(e) {
      this.props.handleKeyPress && this.props.handleKeyPress(e.key);

      if (e.key === 'Enter') {
        e.preventDefault();
        this.onInputChangeFinish(e.key);
      }
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange() {
      this.setState({
        value: this.input.value
      });
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      this.setState({
        focused: true
      });
      this.input.focus();
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      if (this.state.focused) {
        this.setState({
          focused: false
        });
        this.onInputChangeFinish();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var containerClasses = classNames('text-box-input', (_classNames = {}, _defineProperty(_classNames, this.props.className, this.props.className !== undefined), _defineProperty(_classNames, "width-".concat(this.props.width), this.props.width !== undefined), _defineProperty(_classNames, 'read-only', !this.props.onChange), _defineProperty(_classNames, "focused", this.state.focused), _classNames));
      return React__default.createElement("div", {
        className: containerClasses,
        onClick: this.onFocus
      }, React__default.createElement("span", null, this.props.title), React__default.createElement("input", {
        id: this.props.id,
        name: this.props.name || '',
        autoComplete: this.props.autoComplete || 'off',
        type: this.props.type || 'text',
        maxLength: this.props.maxLength || 1000,
        ref: function ref(i) {
          _this2.input = i;
        },
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyPress: this.handleKeyPress,
        onKeyUp: this.handleKeyUp,
        onChange: this.handleInputChange,
        value: this.state.value,
        placeholder: this.props.placeholder || ''
      }));
    }
  }]);

  return LayoutTextBoxInput;
}(React.Component);

_defineProperty(LayoutTextBoxInput, "defaultProps", {
  value: ''
});

module.exports = LayoutTextBoxInput;